import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { CookieConsentService } from '@app/core/services/cookie-consent.service';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-cookie-consent-banner',
  template: `
    @if (cookieConsent.visible()) {
      <div class="cookie-consent" role="dialog" aria-labelledby="cookie-consent-title">
        <p id="cookie-consent-title" class="cookie-consent__message">
          This website uses cookies to ensure you get the best experience on our website.
          <a class="cookie-consent__link" href="https://cookiesandyou.com" target="_blank" rel="noopener">
            Learn more
          </a>
        </p>
        <div class="cookie-consent__actions">
          <button type="button" class="cookie-consent__button cookie-consent__button--secondary" (click)="deny()">
            Refuse cookies
          </button>
          <button type="button" class="cookie-consent__button cookie-consent__button--primary" (click)="dismiss()">
            Got it!
          </button>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .cookie-consent {
        position: fixed;
        top: 16px;
        right: 16px;
        z-index: 2147483646;
        display: flex;
        flex-direction: column;
        gap: 12px;
        max-width: min(92vw, 360px);
        padding: 16px 18px;
        border-radius: 8px;
        background: #12395e;
        color: #fff;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.24);
        font-family: Montserrat, sans-serif;
        font-size: 14px;
        line-height: 1.45;
      }

      .cookie-consent__message {
        margin: 0;
      }

      .cookie-consent__link {
        color: #fff;
        font-weight: 600;
        text-decoration: underline;
      }

      .cookie-consent__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: flex-end;
      }

      .cookie-consent__button {
        border: 0;
        border-radius: 4px;
        padding: 8px 14px;
        font: inherit;
        font-weight: 600;
        cursor: pointer;
      }

      .cookie-consent__button--primary {
        background: #b84a0e;
        color: #fff;
      }

      .cookie-consent__button--secondary {
        background: transparent;
        color: #fff;
        border: 1px solid rgba(255, 255, 255, 0.45);
      }
    `,
  ],
})
export class CookieConsentBannerComponent {
  protected readonly cookieConsent = inject(CookieConsentService);

  dismiss(): void {
    this.cookieConsent.dismiss();
  }

  deny(): void {
    this.cookieConsent.deny();
  }
}
